/**
 * Der `TrennenDialog` als nachgeladener Chunk: er (samt `trennenDialog.css`) gehoert nicht ins
 * Eintrittsbuendel (Grenze in `test/reference/bundle.test.ts`), erst das Oeffnen laedt ihn. Wer den
 * Dialog nur bei Bedarf rendert (`{offen && <TrennenDialogLazy … />}`), zahlt den Abruf erst dann.
 * Verwendet von `ShipTab/DsvSendung.tsx`; der Sammel-Drawer (Task 7) nutzt dieselbe Huelle.
 */
import { lazy, Suspense, useEffect } from "react";
import type { TrennenDialogProps } from "./TrennenDialog.tsx";

const TrennenDialogChunk = lazy(() => import("./TrennenDialog.tsx").then((m) => ({ default: m.TrennenDialog })));

/**
 * Platzhalter, solange der Dialog-Chunk noch laedt: der Dialog hat seinen eigenen Escape-Listener noch nicht, ein
 * Escape in dieser Phase wuerde sonst die Board-Auswahl leeren oder den Drawer schliessen. Gleiche Fangphase auf
 * `window` und gleiches Verschlucken wie im `TrennenDialog`; danach uebernimmt dieser.
 */
export function EscapeSperre() {
  useEffect(() => {
    const beiTaste = (e: KeyboardEvent): void => {
      if (e.key !== "Escape") return;
      e.preventDefault();
      e.stopPropagation();
    };
    window.addEventListener("keydown", beiTaste, true);
    return () => window.removeEventListener("keydown", beiTaste, true);
  }, []);
  return null;
}

export function TrennenDialogLazy(props: TrennenDialogProps) {
  return (
    <Suspense fallback={<EscapeSperre />}>
      <TrennenDialogChunk {...props} />
    </Suspense>
  );
}
